// Güncel Package Arayüzü
export interface Package {
    id: string;
    name: string;
    price: number;
    features: string[];
    freeTableCardQty: number;
    freeHandCardQty: number;
    freeBoardQty?: number; // YENİ: Karşılama panosu hak adeti
    // YENİ EKLENEN ALANLAR:
    originalPrice?: number;       // İndirim öncesi üstü çizilecek fiyat
    discountDeadline?: string;    // Geri sayım için bitiş tarihi (ISO String)
}

// Yardımcı Fonksiyon: Bugünden itibaren X gün sonrasını hesaplar
const getDeadline = (days: number) => {
    const date = new Date();
    date.setDate(date.getDate() + days);
    return date.toISOString();
};

export const PACKAGE_CATEGORIES = [
    {
        id: "dugun",
        name: "Şık Deneyim",
        description: "Bu paketler çift yüzlü tasarım kartları, gecenin görevleri el kartları ve dijital anı havuzunu içerir.",
        packages: [
            {
                id: 'dugun-ozel',
                name: "Sadece Qr Kod",
                price: 1200,
                originalPrice: 2050,
                discountDeadline: "2026-08-15T23:59:59",
                features: [
                    "<div class='text-[13px] leading-snug'><strong class='font-extrabold text-neutral-800 text-[13.5px]'>Tasarım QR Kartları:</strong> Sonraki adımda basılı kart eklenebilir.</div>",
                    "<div class='text-[13px] leading-snug'><strong class='font-extrabold text-neutral-800 text-[13.5px]'>Sıfır Zahmet, Kolay Yükleme:</strong> Uygulamasız, üyeliksiz tek tıkla anı yükleme.</div>",
                    "<div class='text-[13px] leading-snug'><strong class='font-extrabold text-[#E45078] text-[13.5px]'>Yapay Zeka (AI) Dokunuşu:</strong> AI Görüntü İyileştirme ve Filtreler.</div>",
                    "<div class='text-[13px] leading-snug'><strong class='font-extrabold text-neutral-800 text-[13.5px]'>Akıllı Anı Defteri:</strong> Misafirlerden yazılı notlar ve sesli mesajlar.</div>",
                    "<div class='text-[13px] leading-snug'><strong class='font-extrabold text-neutral-800 text-[13.5px]'>Sınırsız Depolama (9 Ay):</strong> 3 albüm, orijinal kalitede indirme 📥</div>",
                    "<div class='text-[13px] leading-snug'><strong class='font-extrabold text-neutral-800 text-[13.5px]'>14 Gün Güvence:</strong> Şartsız koşulsuz anında tam iade hakkı.</div>",
                ],
                freeTableCardQty: 0,
                freeHandCardQty: 0,
                freeBoardQty: 0,
                aiEnhanceLimit: 50,
                aiArtisticLimit: 10
            },
            {
                id: 'dugun-baslangic',
                name: "Başlangıç Düğün",
                price: 1350,
                originalPrice: 2550,
                discountDeadline: "2026-08-15T23:59:59",
                features: [
                    "<div class='text-[13px] leading-snug'><strong class='font-extrabold text-neutral-800 text-[13.5px]'>Tasarım QR Masa Kartları:</strong> <strong>15 adet masa kartı</strong></div>",
                    "<div class='text-[13px] leading-snug'><strong class='font-extrabold text-neutral-800 text-[13.5px]'>Görevler QR El Kartları:</strong> <strong>24 adet 'Gecenin Görevleri' el kartı</strong></div>",
                    "<div class='text-[13px] leading-snug'><strong class='font-extrabold text-neutral-800 text-[13.5px]'>Sıfır Zahmet, Kolay Yükleme:</strong> Uygulamasız, üyeliksiz tek tıkla anı yükleme.</div>",
                    "<div class='text-[13px] leading-snug'><strong class='font-extrabold text-neutral-800 text-[13.5px]'>Ana Dijital Albüm:</strong> Tek albüm ve 3 renk seçeneği.</div>",
                    "<div class='text-[13px] leading-snug'><strong class='font-extrabold text-neutral-800 text-[13.5px]'>Sınırsız Depolama (6 Ay):</strong> Orijinal kalitede indirebilirsiniz 📥</div>",
                    "<div class='text-[13px] leading-snug'><strong class='font-extrabold text-neutral-800 text-[13.5px]'>14 Gün Güvence:</strong> Şartsız koşulsuz anında tam iade hakkı.</div>",
                ],
                freeTableCardQty: 15,
                freeHandCardQty: 24,
                freeBoardQty: 0
            },
            {
                id: 'dugun-standart',
                name: "Standart Düğün",
                price: 1900,
                originalPrice: 3050,
                discountDeadline: "2026-08-15T23:59:59",
                features: [
                    "<div class='text-[13px] leading-snug'><strong class='font-extrabold text-neutral-800 text-[13.5px]'>Tasarım QR Masa Kartları:</strong> <strong>50 adet masa kartı</strong></div>",
                    "<div class='text-[13px] leading-snug'><strong class='font-extrabold text-neutral-800 text-[13.5px]'>Görevler QR El Kartları:</strong> <strong>40 adet 'Gecenin Görevleri' el kartı</strong></div>",
                    "<div class='text-[13px] leading-snug'><strong class='font-extrabold text-neutral-800 text-[13.5px]'>Sıfır Zahmet, Kolay Yükleme:</strong> Uygulamasız, üyeliksiz tek tıkla anı yükleme.</div>",
                    "<div class='text-[13px] leading-snug'><strong class='font-extrabold text-[#E45078] text-[13.5px]'>Yapay Zeka (AI) Dokunuşu:</strong> AI Görüntü İyileştirme ve Filtreler.</div>",
                    "<div class='text-[13px] leading-snug'><strong class='font-extrabold text-neutral-800 text-[13.5px]'>Akıllı Anı Defteri:</strong> Misafirlerden yazılı notlar ve sesli mesajlar.</div>",
                    "<div class='text-[13px] leading-snug'><strong class='font-extrabold text-neutral-800 text-[13.5px]'>Sınırsız Depolama (9 Ay):</strong> 2 albüm, 6 renk, orijinal kalitede indirme 📥</div>",
                    "<div class='text-[13px] leading-snug'><strong class='font-extrabold text-neutral-800 text-[13.5px]'>14 Gün Güvence:</strong> Şartsız koşulsuz anında tam iade hakkı.</div>",
                ],
                freeTableCardQty: 50,
                freeHandCardQty: 40,
                aiEnhanceLimit: 50,
                aiArtisticLimit: 10,
                freeBoardQty: 0
            },
            {
                id: 'dugun-pro',
                name: "Pro Düğün",
                price: 3950,
                originalPrice: 6050,
                discountDeadline: "2026-08-15T23:59:59",
                features: [
                    "<div class='text-[13px] leading-snug'><strong class='font-extrabold text-neutral-800 text-[13.5px]'>Tasarım QR Masa Kartları:</strong> <strong>120 adet masa kartı</strong></div>",
                    "<div class='text-[13px] leading-snug'><strong class='font-extrabold text-neutral-800 text-[13.5px]'>Görevler QR El Kartları:</strong> <strong>120 adet 'Gecenin Görevleri' el kartı</strong></div>",
                    "<div class='text-[13px] leading-snug'><strong class='font-extrabold text-neutral-800 text-[13.5px]'>Karşılama Panosu:</strong> <strong>1 adet karşılama panosu</strong></div>",
                    "<div class='text-[13px] leading-snug'><strong class='font-extrabold text-neutral-800 text-[13.5px]'>Sıfır Zahmet, Kolay Yükleme:</strong> Uygulamasız, üyeliksiz tek tıkla anı yükleme.</div>",
                    "<div class='text-[13px] leading-snug'><strong class='font-extrabold text-[#E45078] text-[13.5px]'>Yapay Zeka (AI) Dokunuşu:</strong> AI Görüntü İyileştirme ve Filtreler.</div>",
                    "<div class='text-[13px] leading-snug'><strong class='font-extrabold text-neutral-800 text-[13.5px]'>Akıllı Anı Defteri:</strong> Misafirlerden yazılı notlar ve sesli mesajlar.</div>",
                    "<div class='text-[13px] leading-snug'><strong class='font-extrabold text-neutral-800 text-[13.5px]'>Sınırsız Depolama (12 Ay):</strong> 3 albüm, orijinal kalitede indirme 📥</div>",
                    "<div class='text-[13px] leading-snug'><strong class='font-extrabold text-neutral-800 text-[13.5px]'>14 Gün Güvence:</strong> Şartsız koşulsuz anında tam iade hakkı.</div>",
                ],
                freeTableCardQty: 120,
                freeHandCardQty: 120,
                freeBoardQty: 1,
                aiEnhanceLimit: 50,
                aiArtisticLimit: 10
            },
        ] as Package[],
    },
    {
        id: "ekonomik",
        name: "Ekonomik Paketler",
        description: "Bu paketler bütçe dostu tek yüzlü masa kartları ve dijital anı havuzunu içerir.",
        packages: [
            {
                id: 'ekonomik-1',
                name: "Ekonomik Paket 1",
                price: 990,
                originalPrice: 1650,
                discountDeadline: "2026-08-15T23:59:59",
                features: [
                    "<div class='text-[13px] leading-snug'><strong class='font-extrabold text-neutral-800 text-[13.5px]'>Tek Yüzlü Masa Kartları:</strong> <strong>25 adet tek yüzlü masa kartı</strong></div>",
                    "<div class='text-[13px] leading-snug'><strong class='font-extrabold text-neutral-800 text-[13.5px]'>Sıfır Zahmet, Kolay Yükleme:</strong> Uygulamasız, üyeliksiz tek tıkla anı yükleme.</div>",
                    "<div class='text-[13px] leading-snug'><strong class='font-extrabold text-neutral-800 text-[13.5px]'>Akıllı Anı Defteri:</strong> Misafirlerden yazılı notlar ve sesli mesajlar.</div>",
                    "<div class='text-[13px] leading-snug'><strong class='font-extrabold text-neutral-800 text-[13.5px]'>Sınırsız Depolama (3 Ay):</strong> Orijinal kalitede indirebilirsiniz 📥</div>",
                    "<div class='text-[13px] leading-snug'><strong class='font-extrabold text-neutral-800 text-[13.5px]'>14 Gün Güvence:</strong> Şartsız koşulsuz anında tam iade hakkı.</div>",
                ],
                freeTableCardQty: 25,
                freeHandCardQty: 0,
                freeBoardQty: 0
            },
            {
                id: 'ekonomik-2',
                name: "Ekonomik Paket 2",
                price: 1250,
                originalPrice: 2100,
                discountDeadline: "2026-08-15T23:59:59",
                features: [
                    "<div class='text-[13px] leading-snug'><strong class='font-extrabold text-neutral-800 text-[13.5px]'>Tek Yüzlü Masa Kartları:</strong> <strong>50 adet tek yüzlü masa kartı</strong></div>",
                    "<div class='text-[13px] leading-snug'><strong class='font-extrabold text-neutral-800 text-[13.5px]'>Sıfır Zahmet, Kolay Yükleme:</strong> Uygulamasız, üyeliksiz tek tıkla anı yükleme.</div>",
                    "<div class='text-[13px] leading-snug'><strong class='font-extrabold text-neutral-800 text-[13.5px]'>Akıllı Anı Defteri:</strong> Misafirlerden yazılı notlar ve sesli mesajlar.</div>",
                    "<div class='text-[13px] leading-snug'><strong class='font-extrabold text-neutral-800 text-[13.5px]'>Sınırsız Depolama (6 Ay):</strong> Orijinal kalitede indirebilirsiniz 📥</div>",
                    "<div class='text-[13px] leading-snug'><strong class='font-extrabold text-neutral-800 text-[13.5px]'>14 Gün Güvence:</strong> Şartsız koşulsuz anında tam iade hakkı.</div>",
                ],
                freeTableCardQty: 50,
                freeHandCardQty: 0,
                freeBoardQty: 0
            },
            {
                id: 'ekonomik-3',
                name: "Ekonomik Paket 3",
                price: 1600,
                originalPrice: 2700,
                discountDeadline: "2026-08-15T23:59:59",
                features: [
                    "<div class='text-[13px] leading-snug'><strong class='font-extrabold text-neutral-800 text-[13.5px]'>Tek Yüzlü Masa Kartları:</strong> <strong>100 adet tek yüzlü masa kartı</strong></div>",
                    "<div class='text-[13px] leading-snug'><strong class='font-extrabold text-neutral-800 text-[13.5px]'>Sıfır Zahmet, Kolay Yükleme:</strong> Uygulamasız, üyeliksiz tek tıkla anı yükleme.</div>",
                    "<div class='text-[13px] leading-snug'><strong class='font-extrabold text-neutral-800 text-[13.5px]'>Akıllı Anı Defteri:</strong> Misafirlerden yazılı notlar ve sesli mesajlar.</div>",
                    "<div class='text-[13px] leading-snug'><strong class='font-extrabold text-neutral-800 text-[13.5px]'>Sınırsız Depolama (6 Ay):</strong> Orijinal kalitede indirebilirsiniz 📥</div>",
                    "<div class='text-[13px] leading-snug'><strong class='font-extrabold text-neutral-800 text-[13.5px]'>14 Gün Güvence:</strong> Şartsız koşulsuz anında tam iade hakkı.</div>",
                ],
                freeTableCardQty: 100,
                freeHandCardQty: 0,
                freeBoardQty: 0
            },
            {
                id: 'ekonomik-4',
                name: "Ekonomik Paket 4",
                price: 1900,
                originalPrice: 3200,
                discountDeadline: "2026-08-15T23:59:59",
                features: [
                    "<div class='text-[13px] leading-snug'><strong class='font-extrabold text-neutral-800 text-[13.5px]'>Tek Yüzlü Masa Kartları:</strong> <strong>150 adet tek yüzlü masa kartı</strong></div>",
                    "<div class='text-[13px] leading-snug'><strong class='font-extrabold text-neutral-800 text-[13.5px]'>Sıfır Zahmet, Kolay Yükleme:</strong> Uygulamasız, üyeliksiz tek tıkla anı yükleme.</div>",
                    "<div class='text-[13px] leading-snug'><strong class='font-extrabold text-neutral-800 text-[13.5px]'>Akıllı Anı Defteri:</strong> Misafirlerden yazılı notlar ve sesli mesajlar.</div>",
                    "<div class='text-[13px] leading-snug'><strong class='font-extrabold text-neutral-800 text-[13.5px]'>Sınırsız Depolama (6 Ay):</strong> Orijinal kalitede indirebilirsiniz 📥</div>",
                    "<div class='text-[13px] leading-snug'><strong class='font-extrabold text-neutral-800 text-[13.5px]'>14 Gün Güvence:</strong> Şartsız koşulsuz anında tam iade hakkı.</div>",
                ],
                freeTableCardQty: 150,
                freeHandCardQty: 0,
                freeBoardQty: 0
            },
            {
                id: 'ekonomik-5',
                name: "Ekonomik Paket 5",
                price: 2150,
                originalPrice: 3600,
                discountDeadline: "2026-08-15T23:59:59",
                features: [
                    "<div class='text-[13px] leading-snug'><strong class='font-extrabold text-neutral-800 text-[13.5px]'>Tek Yüzlü Masa Kartları:</strong> <strong>200 adet tek yüzlü masa kartı</strong></div>",
                    "<div class='text-[13px] leading-snug'><strong class='font-extrabold text-neutral-800 text-[13.5px]'>Sıfır Zahmet, Kolay Yükleme:</strong> Uygulamasız, üyeliksiz tek tıkla anı yükleme.</div>",
                    "<div class='text-[13px] leading-snug'><strong class='font-extrabold text-neutral-800 text-[13.5px]'>Akıllı Anı Defteri:</strong> Misafirlerden yazılı notlar ve sesli mesajlar.</div>",
                    "<div class='text-[13px] leading-snug'><strong class='font-extrabold text-neutral-800 text-[13.5px]'>Sınırsız Depolama (6 Ay):</strong> Orijinal kalitede indirebilirsiniz 📥</div>",
                    "<div class='text-[13px] leading-snug'><strong class='font-extrabold text-neutral-800 text-[13.5px]'>14 Gün Güvence:</strong> Şartsız koşulsuz anında tam iade hakkı.</div>",
                ],
                freeTableCardQty: 200,
                freeHandCardQty: 0,
                freeBoardQty: 0
            }
        ] as Package[]
    }
];

// ... (Dosyanın geri kalanı aynı kalabilir: MASA_KARTI_TASARIMLARI, EL_KARTI_TASARIMLARI, PRODUCTS)
export const MASA_KARTI_TASARIMLARI = [
    {
        id: 'klasik-masa',
        name: 'Klasik Beyaz',
        designImageUrl: '/baski/masa-karti4-tasarim-beyaz.png',
        productImageUrl: '/baski/masa-karti4-gorunum-beyaz.png'
    },
    {
        id: 'modern-masa-pembe',
        name: 'Modern Pembe',
        designImageUrl: '/baski/masa-karti1-tasarim-pembe.png',
        productImageUrl: '/baski/masa-karti1-gorunum-pembe.png'
    },
    {
        id: 'modern-masa-mavi',
        name: 'Modern Mavi',
        designImageUrl: '/baski/masa-karti2-tasarim-mavi.jpeg',
        productImageUrl: '/baski/masa-karti2-gorunum-mavi.png'
    },
    {
        id: 'modern-masa-nane',
        name: 'Nane Yeşili',
        designImageUrl: '/baski/masa-karti3-tasarim-nane.jpeg',
        productImageUrl: '/baski/masa-karti3-gorunum-nane.png'
    },
    {
        id: 'retro-masa',
        name: 'Retro',
        designImageUrl: '/baski/masa-karti-5.png',
        productImageUrl: '/baski/masa-karti-5.png'
    },
    {
        id: 'fotograf-masa',
        name: 'Fotoğraflı',
        designImageUrl: '/baski/masa-karti-6.png',
        productImageUrl: '/baski/masa-karti-6.png'
    },
];

export const TEK_YUZ_MASA_KARTI_TASARIMLARI = [
    {
        id: 'standart-tek-yuz',
        name: 'Standart Tek Yüz',
        designImageUrl: '/baski/tek-yuz-masa-karti.png',
        productImageUrl: '/baski/tek-yuz-masa-karti.png'
    }
];

export const EL_KARTI_TASARIMLARI = [
    {
        id: 'sade-el',
        name: 'Sade Arka Plan',
        designImageUrl: '/baski/el-karti1-tasarim.webp',
        productImageUrl: '/baski/el-karti1-gorunum.png'
    },
];

export const PANO_TASARIMLARI = [
    {
        id: 'standart-pano',
        name: 'Standart Pano',
        designImageUrl: '/baski/pano.webp',
        productImageUrl: '/baski/pano.webp'
    },
];

export const PRODUCTS = [
    {
        id: 'el-karti',
        name: 'El Kartı',
        price: 5.00,
        imageUrl: EL_KARTI_TASARIMLARI[0].productImageUrl,
        maxQty: 500
    },
    {
        id: 'masa-karti',
        name: 'Masa Kartı',
        price: 12.00,
        imageUrl: MASA_KARTI_TASARIMLARI[0].productImageUrl,
        maxQty: 300
    },
    {
        id: 'tek-yuz-masa-karti',
        name: 'Tek Yüzlü Masa Kartı',
        price: 7.50,
        imageUrl: TEK_YUZ_MASA_KARTI_TASARIMLARI[0].productImageUrl,
        maxQty: 300
    },
    {
        id: 'karsilama-panosu',
        name: 'Karşılama Panosu',
        price: 900.00,
        imageUrl: PANO_TASARIMLARI[0].productImageUrl,
        maxQty: 10
    },
];